import React from 'react';
import { DashboardPlugin } from '../../../../core/plugin/PluginType';
import PendingLeaveRequestsDashboardPlugin from './PendingLeaveRequestsDashboardPlugin';
import MyLeaveRequestsDashboardPlugin from './MyLeaveRequestsDashboardPlugin';

export const PendingLeaveRequestsDashboardPluginConfiguration: DashboardPlugin = {
    id: 'pending-leave-requests-dashboard-plugin',
    name: 'Ausstehende Urlaubsanträge',
    icon: 'calendar',
    version: '1.0.0',
    description: 'Displays pending leave requests awaiting approval',
    author: 'Your Company',
    type: 'dashboard',
    isPinned: true,
    component: PendingLeaveRequestsDashboardPlugin,
    defaultSize: 'medium',
    defaultPreferences: {},
    requiredPermissions: ['dashboard.plugins.pending-leave-requests.view'],
};

export const MyLeaveRequestsDashboardPluginConfiguration: DashboardPlugin = {
    id: 'my-leave-requests-dashboard-plugin',
    name: 'Meine Abwesenheiten',
    icon: 'absenceCalendar',
    version: '1.0.0',
    description: 'Displays summary of employee statistics',
    author: 'Your Company',
    type: 'dashboard',
    component: MyLeaveRequestsDashboardPlugin,
    defaultSize: 'medium',
    defaultPreferences: {},
    requiredPermissions: ['dashboard.plugins.my-leave-requests.view'],
};